module.exports = __webpack_public_path__ + "img/23.ec68eb25.png";